import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import {List, ListItem, ListItemText, Divider } from "@mui/material";
import {
  caseManagementUrl,
  documentManagementUrl,
  emailService,
  setupManagement,
  smsservice,
  uploadCaseForClientService,
  uploadCaseService,
  uploadCorporateClients,
  uploadIndividualClients,
  userManagementUrl,
  companyManagementUrl,
} from "../../config";
import {
  generateAndExecuteMutation,
  fetchDataEngine,
  graphqlQuery,
  generateAndExecuteBulkMutation,
} from "../Axios/DynamicService";
import { Formik, Field } from "formik";
import * as yup from "yup";
import {
  Autocomplete,
  Box,
  Checkbox,
  FormControlLabel,
  Typography,
} from "@mui/material";
import Swal from "sweetalert2";
import { useTheme } from "@emotion/react";
import { tokens } from "../../theme";
import { CheckBox } from "@mui/icons-material";
import { allCaseStatus, allUsersQuery } from "../Axios/queries";
import {
  getDocumentAccessPermissions,
  getDocumentAccessPermissionsById,
} from "../Axios/Non-DynamicServices";
import {
  MenuItem,
} from "@mui/material";
import { downloadCaseFile, downloadCaseForClientFile, downloadCorporateClientFile, downloadIndividualClientFile, uploadCasefile, uploadCaseForClientfile, uploadCorporateClient, uploadIndividualClient } from "./DynamicFunctions";
import { Print as PrintIcon } from "@mui/icons-material";
import logo from '../../Assets/Images/AGO-Logo.png'

const userbase_url = userManagementUrl.uri
export function CommunicationComponent(props) {
  const { communicationType } = props; // email or sms
  const base_url = emailService.uri;
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const validationSchema = yup.object().shape({
    subjectTitle:
      communicationType === "email"
        ? yup.string().required("Subject is required")
        : yup.string(),
    recipientEmail:
      communicationType === "email"
        ? yup
            .string()
            .email("Invalid email format")
            .required("Recipient email is required")
        : yup.string(),
    recipientNumber:
      communicationType === "sms"
        ? yup
            .string()
            .matches(/^[0-9]+$/, "Phone number must be digits only")
            .required("Recipient number is required")
        : yup.string(),
    body: yup.string().required("Body is required"),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const mutationData =
        communicationType === "email"
          ? {
              subjectTitle: values.subjectTitle,
              recipientEmail: values.recipientEmail,
              body: values.body,
              messageId: 1,
            }
          : {
              phoneNumber: values.recipientNumber,
              body: values.body,
              messageId: 1,
            };
      const response = await generateAndExecuteMutation(
        communicationType === "email" ? "createEmailMessage" : "createMessage",
        mutationData,
        communicationType === "email" ? "email" : "smsmessage",
        communicationType === "email" ? base_url : smsservice.uri
      );

      if (Object.values(response)[0] != null) {
        props.onClose();
        //props.onAction();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `${
            communicationType.charAt(0).toUpperCase() +
            communicationType.slice(1)
          } has been sent successfully.`,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }
    setSubmitting(false);
    props.onClose();
  };

  return (
    <React.Fragment>
      <Dialog open={props.open} onClose={props.onClose}>
        <DialogTitle sx={{ color: colors.grey[100] }}>
          {communicationType === "email" ? "Send Email" : "Send SMS"}
        </DialogTitle>
        <Formik
          initialValues={{
            subjectTitle: "",
            recipientEmail: "",
            recipientNumber: "",
            body: "",
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
            isSubmitting,
          }) => (
            <form onSubmit={handleSubmit}>
              <DialogContent>
                <DialogContentText sx={{ color: colors.greenAccent[400] }}>
                  Fill in the details to send a {communicationType}.
                </DialogContentText>
                {communicationType === "email" && (
                  <>
                    <TextField
                      fullWidth
                      label="Subject Title"
                      name="subjectTitle"
                      variant="filled"
                      value={values.subjectTitle}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.subjectTitle && !!errors.subjectTitle}
                      helperText={touched.subjectTitle && errors.subjectTitle}
                      margin="normal"
                    />
                    <TextField
                      fullWidth
                      label="Recipient Email"
                      name="recipientEmail"
                      variant="filled"
                      value={values.recipientEmail}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.recipientEmail && !!errors.recipientEmail}
                      helperText={
                        touched.recipientEmail && errors.recipientEmail
                      }
                      margin="normal"
                    />
                  </>
                )}
                {communicationType === "sms" && (
                  <TextField
                    fullWidth
                    label="Recipient Number"
                    name="recipientNumber"
                    variant="filled"
                    value={values.recipientNumber}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.recipientNumber && !!errors.recipientNumber}
                    helperText={
                      touched.recipientNumber && errors.recipientNumber
                    }
                    margin="normal"
                  />
                )}
                <TextField
                  fullWidth
                  label="Body"
                  name="body"
                  variant="filled"
                  value={values.body}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.body && !!errors.body}
                  helperText={touched.body && errors.body}
                  margin="normal"
                  multiline
                  rows={4}
                />
              </DialogContent>
              <DialogActions>
                <Button
                  color="error"
                  variant="outlined"
                  onClick={props.onClose}
                >
                  Cancel
                </Button>
                <Button
                  variant="outlined"
                  type="submit"
                  disabled={isSubmitting}
                  color="success"
                >
                  {isSubmitting
                    ? "Sending..."
                    : `Send ${
                        communicationType.charAt(0).toUpperCase() +
                        communicationType.slice(1)
                      }`}
                </Button>
              </DialogActions>
            </form>
          )}
        </Formik>
      </Dialog>
    </React.Fragment>
  );
}

export function AssignTaskModal(props) {
  const [usersData, setUsersData] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const caseId = JSON.parse(localStorage.getItem("CaseId"));
  const base_url = caseManagementUrl.uri;
  const userbase_url = userManagementUrl.uri; // Added missing variable
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  // Set initial values based on props data
  const initialValues = {
    userId: props.data?.asigneeId?.toString() || "", // Convert to string for consistency
  };

  console.log("AssignTaskModal props:", props.data);
  console.log("Initial userId:", initialValues.userId);

  // Fetch all users only once
  useEffect(() => {
    async function fetchAllUsers() {
      try {
        setLoading(true);
        const allUsersData = await graphqlQuery(allUsersQuery, userbase_url);
        if (allUsersData) {
          setUsersData(allUsersData);
          console.log("Users loaded:", allUsersData);
        }
      } catch (error) {
        console.error("Error fetching advocates/users:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchAllUsers();
  }, []);

  const usersOptions = usersData
    ? usersData.map((data) => ({
        value: data.id.toString(), // Ensure consistent string format
        label: `${data.firstName} ${data.lastName}` || data.username,
      }))
    : [];

  const validationSchema = yup.object().shape({
    userId: yup.string().required("User is required"),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    console.log("Submitting form with values:", values);
    
    try {
      const { userId } = values;
      const userIdFromSession = JSON.parse(
        localStorage.getItem("decodedToken")
      ).Id;

      const mutationData = {
        id: props.data.id,
        description: props.data.description,
        dueDate: props.data.dueDate,
        caseId: caseId,
        updatedBy: parseInt(userIdFromSession),
        asigneeId: parseInt(userId), // Convert back to number for API
      };

      console.log("Mutation data:", mutationData);

      const response = await generateAndExecuteMutation(
        "updateCaseTask",
        mutationData,
        "newCaseTask",
        base_url
      );

      console.log("API Response:", response);

      if (response && Object.values(response)[0] != null) {
        props.onClose();
        props.onAction();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Task has been assigned successfully.`,
        });
      } else {
        throw new Error("No response from server");
      }
    } catch (error) {
      console.error("Assignment error:", error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    } finally {
      setSubmitting(false);
      props.onClose();
    }
  };

  return (
    <React.Fragment>
      <Dialog open={props.open} onClose={props.onClose} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ color: colors.grey[100] }}>Assign Task</DialogTitle>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize // This ensures initialValues update when props change
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
            setFieldValue,
            isSubmitting,
          }) => (
            <form onSubmit={handleSubmit}>
              <DialogContent>
                <DialogContentText sx={{ color: colors.greenAccent[400], mb: 2 }}>
                  Select a team member to assign the task to them.
                </DialogContentText>
                
                {loading ? (
                  <Box display="flex" justifyContent="center" p={2}>
                    {/* <CircularProgress /> */}
                  </Box>
                ) : (
                  <Autocomplete
                    options={usersOptions}
                    getOptionLabel={(option) => option.label}
                    value={usersOptions.find(option => option.value === values.userId) || null}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        name="userId" // Added name prop for Formik
                        label="Select User"
                        variant="outlined"
                        onBlur={handleBlur}
                        error={touched.userId && !!errors.userId}
                        helperText={touched.userId && errors.userId}
                        required
                      />
                    )}
                    onChange={(event, newValue) => {
                      setFieldValue("userId", newValue ? newValue.value : "");
                      console.log("Selected user:", newValue);
                    }}
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                  />
                )}
                
          
              </DialogContent>
              <DialogActions>
                <Button
                  color="error"
                  variant="outlined"
                  onClick={props.onClose}
                  disabled={isSubmitting}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  type="submit"
                  disabled={isSubmitting || !values.userId}
                  color="primary"
                >
                  {isSubmitting ? "Assigning..." : "Assign Task"}
                </Button>
              </DialogActions>
            </form>
          )}
        </Formik>
      </Dialog>
    </React.Fragment>
  );
}
// EngagementLetterModal.jsx
//
// NOTE ON IMPORTS: keep whatever imports the original file already had
// (Dialog, DialogTitle, DialogContent, DialogActions, Box, Button, PrintIcon,
// useTheme, tokens, the local `logo` fallback image, etc). In addition to
// those, add the imports below so this component can fetch company data
// and the logo the same way PrintInvoice.jsx does:
//
// import { useState, useEffect } from "react";
// import { graphqlQuery } from "../../../data/Axios/DynamicService"; // adjust path to match your project
// import { companyManagementUrl } from "../../../config";            // adjust path to match your project
// import AGO_Logo from "../../../Assets/Images/AGO-Logo.png";        // adjust path to match your project

const baseURL = companyManagementUrl.uri;

const LOGO_ORIGIN = (() => {
  try {
    return new URL(baseURL).origin;
  } catch {
    return 'https://matrix.mcb.co.ke';
  }
})();
 
// ---- Logo path normalization (identical logic to PrintInvoice.jsx, ----
// ---- except it resolves against LOGO_ORIGIN instead of baseURL)     ----
const normalizeLogoPath = (rawPath) => {
  if (!rawPath || typeof rawPath !== 'string') return null;
 
  const trimmed = rawPath.trim();
  if (!trimmed) return null;
 
  const isWindowsPath = /^[a-zA-Z]:[\\/]/.test(trimmed);
  if (isWindowsPath) return null;
 
  let cleaned = trimmed.replace(/^(\.\.\/|\.\/)+/, '');
  cleaned = cleaned.replace(/^\/+/, '');
 
  if (!cleaned.startsWith('assets/')) {
    return null;
  }
 
  return `${LOGO_ORIGIN.replace(/\/+$/, '')}/${cleaned}`;
};

// ---- Color extraction helpers (identical logic to PrintInvoice.jsx) ----
const DEFAULT_COLORS = { primary: "#6d1f1f", secondary: "#9EBB3C" };

const toHex = (r, g, b) =>
  `#${[r, g, b].map((v) => Math.max(0, Math.min(255, v)).toString(16).padStart(2, "0")).join("")}`;

const colorDistance = (a, b) =>
  Math.sqrt((a[0] - b[0]) ** 2 + (a[1] - b[1]) ** 2 + (a[2] - b[2]) ** 2);

const luminance = (hex) => {
  const c = hex.replace('#', '');
  const r = parseInt(c.substring(0, 2), 16) / 255;
  const g = parseInt(c.substring(2, 4), 16) / 255;
  const b = parseInt(c.substring(4, 6), 16) / 255;
  const [rl, gl, bl] = [r, g, b].map((v) =>
    v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4)
  );
  return 0.2126 * rl + 0.7152 * gl + 0.0722 * bl;
};

const readableTextColor = (hex) => (luminance(hex) > 0.5 ? "#1a1a1a" : "#ffffff");

const extractColorsFromImage = (imgSrc) => {
  return new Promise((resolve) => {
    if (!imgSrc) return resolve(DEFAULT_COLORS);

    const img = new Image();
    img.crossOrigin = "Anonymous";
    img.onload = () => {
      try {
        const size = 60;
        const canvas = document.createElement("canvas");
        canvas.width = size;
        canvas.height = size;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, size, size);
        const { data } = ctx.getImageData(0, 0, size, size);

        const counts = {};
        for (let i = 0; i < data.length; i += 4) {
          const [r, g, b, a] = [data[i], data[i + 1], data[i + 2], data[i + 3]];
          if (a < 200) continue;
          const brightness = (r + g + b) / 3;
          if (brightness > 235 || brightness < 20) continue;

          const key = [
            Math.round(r / 16) * 16,
            Math.round(g / 16) * 16,
            Math.round(b / 16) * 16,
          ].join(",");
          counts[key] = (counts[key] || 0) + 1;
        }

        const sorted = Object.entries(counts).sort((a, b) => b[1] - a[1]);
        if (sorted.length === 0) return resolve(DEFAULT_COLORS);

        const primaryRgb = sorted[0][0].split(",").map(Number);
        const primary = toHex(...primaryRgb);

        let secondary = DEFAULT_COLORS.secondary;
        for (let i = 1; i < sorted.length; i++) {
          const rgb = sorted[i][0].split(",").map(Number);
          if (colorDistance(primaryRgb, rgb) > 90) {
            secondary = toHex(...rgb);
            break;
          }
        }

        resolve({ primary, secondary });
      } catch (err) {
        console.error("Color extraction failed:", err);
        resolve(DEFAULT_COLORS);
      }
    };
    img.onerror = () => resolve(DEFAULT_COLORS);
    img.src = imgSrc;
  });
};
// -----------------------------------

export function EngagementLetterModal(props) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const companyId = decodedToken ? parseInt(decodedToken.CompanyId) : null;

  const [companyData, setCompanyData] = useState(null);
  const [companyLoading, setCompanyLoading] = useState(true);
  const [logoUrl, setLogoUrl] = useState(null);
  const [logoLoadFailed, setLogoLoadFailed] = useState(false);
  const [brandColors, setBrandColors] = useState(DEFAULT_COLORS);

  console.log("PROPS", props);

  // ---- Fetch company details + derive logo/brand colors, same pattern as PrintInvoice ----
  useEffect(() => {
    const fetchCompanyData = async () => {
      try {
        setCompanyLoading(true);

        const companyQuery = `
          {
          allCompanies {
                id
                companyName
                companyEmail
                contactEmail
                contactEmailPassword
                emailDisplayName
                emailClient
                emailClientPortNumber
                subscriptionId
                createdBy
                createdDate
                updatedBy
                updatedDate
                logoPath
                address
                poBox
                phone
                mobile
                website
                pinVat
                tagline
            }
        }
        `;

        const response = await graphqlQuery(
          companyQuery,
          companyManagementUrl.uri,
        );

        if (response && response.length > 0) {
          const company = response.find((c) => c.id === companyId) || response[0];
          setCompanyData(company);

          const normalizedLogoUrl = normalizeLogoPath(company.logoPath);
          setLogoUrl(normalizedLogoUrl);
          setLogoLoadFailed(false);

          if (normalizedLogoUrl) {
            const extracted = await extractColorsFromImage(normalizedLogoUrl);
            setBrandColors(extracted);
          } else {
            setBrandColors(DEFAULT_COLORS);
          }
        }
      } catch (err) {
        console.error("Error fetching company data:", err);
        setBrandColors(DEFAULT_COLORS);
      } finally {
        setCompanyLoading(false);
      }
    };

    fetchCompanyData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Dynamic company info with the same "set at company management" fallback
  // convention used on the invoice, so the letter never renders blank fields.
  const companyInfo = {
    name: companyData?.companyName || "set at company management",
    address: companyData?.address || "set at company management",
    poBox: companyData?.poBox || "set at company management",
    phone: companyData?.phone || "set at company management",
    mobile: companyData?.mobile || "set at company management",
    email: companyData?.companyEmail || "set at company management",
    website: companyData?.website || "set at company management",
    pinVat: companyData?.pinVat || "set at company management",
    tagline: companyData?.tagline || "set at company management",
  };

  const primaryColor = brandColors.primary;
  const secondaryColor = brandColors.secondary;
  const primaryText = readableTextColor(primaryColor);

  const resolvedLogoSrc = logoUrl && !logoLoadFailed ? logoUrl : logo; // `logo` is the existing local fallback import
  const handleLogoError = () => setLogoLoadFailed(true);

  // Get client name from props, with fallbacks
  const getClientName = () => {
    if (!props.data) return "Client";

    const { data } = props;

    // Try different possible field names for first and last name
    const firstName = data.firstName || data.firstname || data.clientFirstName || data.companyName || "";
    const lastName = data.lastName || data.lastname || data.clientLastName || "";

    // If we have both names, combine them
    if (firstName && lastName) {
      return `${firstName} ${lastName}`.toUpperCase();
    }

    // If we have only one name, use that
    if (firstName || lastName) {
      return (firstName || lastName).toUpperCase();
    }

    // Fallback to clientName or other fields
    return data.clientName || data.name || "Client";
  };

  const clientName = getClientName();

  const handlePrint = () => {
    const printContent = document.getElementById("engagement-letter-print");
    const printStyles = `
      <style>
        @media print {
          body { 
            margin: 0 !important; 
            padding: 0 !important; 
            font-family: 'Segoe UI', Arial, sans-serif !important;
            font-size: 10pt !important;
            line-height: 1.4 !important;
            color: #2d2d2d !important;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
          .print-container { 
            padding: 15px 20px !important; 
            max-width: 750px !important;
            margin: 0 auto !important;
            box-sizing: border-box !important;
          }
          .no-print { display: none !important; }
          
          .logo-container img {
            width: 80px !important;
            height: 80px !important;
            display: block;
            margin: 0 auto 8px auto !important;
          }
          
          .header-section {
            text-align: center !important;
            margin-bottom: 15px !important;
            padding-bottom: 10px !important;
            border-bottom: 2px solid ${primaryColor} !important;
          }
          
          .firm-name {
            font-size: 12pt !important;
            font-weight: 700 !important;
            color: ${primaryColor} !important;
            letter-spacing: 0.5px !important;
            margin-bottom: 5px !important;
            line-height: 1.2 !important;
          }
          
          .contact-info {
            font-size: 9pt !important;
            color: #4a4a4a !important;
            line-height: 1.3 !important;
          }
          
          .letter-content {
            font-size: 10pt !important;
            line-height: 1.4 !important;
            color: #2d2d2d !important;
          }
          
          .letter-content p {
            margin-bottom: 8px !important;
            text-align: justify !important;
          }
          
          .date-section {
            text-align: right !important;
            margin-bottom: 15px !important;
            font-size: 10pt !important;
            color: #2d2d2d !important;
          }
          
          .subject-line {
            font-weight: 700 !important;
            color: ${primaryColor} !important;
            margin: 10px 0 !important;
            font-size: 10pt !important;
          }
          
          .consent-section {
            margin-top: 20px !important;
            padding: 12px !important;
            background-color: #fafafa !important;
            border: 1.5px solid ${primaryColor} !important;
            border-radius: 3px !important;
          }
          
          .consent-text {
            font-weight: 400 !important;
            font-size: 9pt !important;
            line-height: 1.4 !important;
            color: #2d2d2d !important;
            margin-bottom: 12px !important;
          }
          
          .signature-fields {
            display: grid !important;
            grid-template-columns: 1fr 1fr 1fr !important;
            gap: 10px !important;
            margin-top: 15px !important;
            font-size: 9pt !important;
          }
          
          .signature-line {
            border-bottom: 1px solid #2d2d2d !important;
            display: inline-block !important;
            min-width: 100% !important;
            margin-left: 0 !important;
            height: 25px !important;
          }
          
          * { 
            box-sizing: border-box !important;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
          
          @page {
            margin: 0.5in !important;
            size: letter portrait !important;
          }

          /* Force single page */
          html, body {
            height: auto !important;
            overflow: hidden !important;
          }
          
          .print-container {
            height: auto !important;
            max-height: 10.5in !important;
            overflow: hidden !important;
          }
        }
      </style>
    `;

    const WinPrint = window.open("", "", "width=850,height=700");
    WinPrint.document.write(`
      <html>
        <head>
          <title>Engagement Letter - ${clientName}</title>
          ${printStyles}
        </head>
        <body>
          <div class="print-container">
            ${printContent.innerHTML}
          </div>
        </body>
      </html>
    `);
    WinPrint.document.close();
    WinPrint.focus();
    setTimeout(() => {
      WinPrint.print();
      WinPrint.close();
    }, 500);
  };

  const now = new Date();
  const day = now.getDate();
  const month = now.toLocaleString("en-US", { month: "long" });
  const year = now.getFullYear();

  // Format date as "17th November, 2025"
  const getOrdinalSuffix = (day) => {
    if (day > 3 && day < 21) return 'th';
    switch (day % 10) {
      case 1: return "st";
      case 2: return "nd";
      case 3: return "rd";
      default: return "th";
    }
  };

  const formattedDate = `${day}${getOrdinalSuffix(day)} ${month}, ${year}`;

  return (
    <Dialog open={props.open} onClose={props.onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ color: colors.grey[100] }} className="no-print">
        Engagement Letter - {clientName}
      </DialogTitle>

      <DialogContent>
        <Box
          id="engagement-letter-print"
          sx={{
            bgcolor: "#fff",
            color: "#2d2d2d",
            p: 3,
            fontFamily: "'Segoe UI', Arial, sans-serif",
            '@media print': {
              p: 0,
              m: 0,
              boxShadow: 'none',
              backgroundColor: 'white'
            }
          }}
        >
          {/* ===================== PROFESSIONAL LETTER FORMAT ===================== */}
          <div className="letter-content" style={{ 
            fontFamily: "'Segoe UI', Arial, sans-serif", 
            lineHeight: 1.4,
            maxWidth: '750px',
            margin: '0 auto',
            fontSize: '10pt',
            color: '#2d2d2d'
          }}>

            {/* Header Section with Logo and Dynamic Brand Colors */}
            <div className="header-section" style={{ 
              marginBottom: "15px", 
              textAlign: "center",
              paddingBottom: "10px",
              borderBottom: `2px solid ${primaryColor}`
            }}>
              {/* Logo Container */}
              <div className="logo-container">
                {companyLoading ? (
                  <div style={{
                    width: "80px",
                    height: "80px",
                    margin: "0 auto 8px",
                    borderRadius: "3px",
                    background: `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%)`,
                    opacity: 0.4
                  }} />
                ) : (
                  <img
                    src={resolvedLogoSrc}
                    alt={companyInfo.name}
                    style={{
                      width: "80px",
                      height: "80px",
                      objectFit: "contain",
                      marginBottom: "8px",
                      display: "block",
                      marginLeft: "auto",
                      marginRight: "auto"
                    }}
                    onError={handleLogoError}
                  />
                )}
              </div>
              
              <div className="firm-name" style={{ 
                fontSize: "12pt", 
                fontWeight: "700",
                color: primaryColor,
                letterSpacing: "0.5px",
                marginBottom: "5px",
                lineHeight: "1.2"
              }}>
                {companyInfo.name.toUpperCase()}
              </div>
              
              <div className="contact-info" style={{ 
                fontSize: "9pt", 
                color: "#4a4a4a", 
                lineHeight: 1.3 
              }}>
                <div style={{ marginBottom: "2px" }}>
                  {companyInfo.poBox ? `P.O Box ${companyInfo.address}` : ""}
                </div>
                <div>Tel: {companyInfo.phone} | Email: {companyInfo.email}</div>
              </div>
            </div>

            {/* Date Section */}
            <div className="date-section" style={{ 
              marginBottom: "15px", 
              textAlign: "right",
              fontSize: "10pt",
              color: "#2d2d2d"
            }}>
              <p style={{ margin: 0 }}>
                <strong>{formattedDate}</strong>
              </p>
            </div>

            {/* Salutation */}
            <p style={{ 
              marginBottom: "10px", 
              fontSize: "10pt",
              color: "#2d2d2d" 
            }}>
              Dear <strong>{clientName}</strong>,
            </p>

            {/* Subject Line */}
            <p className="subject-line" style={{ 
              marginBottom: "10px",
              fontWeight: "700",
              fontSize: "10pt",
              color: primaryColor
            }}>
              RE: REPRESENTATION BY {companyInfo.name.toUpperCase()}
            </p>

            {/* Letter Body Content */}
            <div>
              <p style={{ 
                textAlign: "justify", 
                marginBottom: "8px", 
                fontSize: "10pt",
                lineHeight: "1.4" 
              }}>
                Thank you for consulting the firm of {companyInfo.name}. Our primary objective will
                be to provide you with the best possible legal services available to deal with your legal matter.
              </p>

              <p style={{ 
                textAlign: "justify", 
                marginBottom: "8px", 
                fontSize: "10pt",
                lineHeight: "1.4" 
              }}>
                We may send you pleadings, documents, correspondence, and other information throughout the case.
                These copies will be your file copies. Please retain them. We will also keep the information in a file in our
                office, which will be our file. Please bring your copy of the file to all of our meetings so that we both have
                all the necessary information in front of us. When we have completed all the legal work necessary for your
                case, we will close your file and return original documents to you.
              </p>

              <p style={{ 
                textAlign: "justify", 
                marginBottom: "8px", 
                fontSize: "10pt",
                lineHeight: "1.4" 
              }}>
                We have included a copy of this letter for your review, signature, and return to us in the postage-paid
                envelope. If any of the information in this letter is not consistent with your understanding of our
                agreement, please contact {companyInfo.name} before signing the letter.
                Otherwise, please sign the enclosed copy of this letter and return it to us.
              </p>

              <p style={{ 
                textAlign: "justify", 
                marginBottom: "8px", 
                fontSize: "10pt",
                lineHeight: "1.4" 
              }}>
                On behalf of the firm, we are happy to represent you in this matter. If you have any questions, please
                contact us at your convenience.
              </p>
            </div>

            {/* Closing */}
            <p style={{ 
              marginBottom: "5px", 
              fontSize: "10pt",
              marginTop: "15px" 
            }}>
              Very truly yours,
            </p>

            {/* Firm Signature Section */}
            <div style={{ marginBottom: "20px", marginTop: "10px" }}>
              <div style={{ 
                display: "inline-block",
                minWidth: "200px"
              }}>
                <p style={{ 
                  marginBottom: "2px", 
                  fontSize: "9pt",
                  color: "#4a4a4a",
                  fontWeight: "600"
                }}>
                  Advocate Signature:
                </p>
                <div className="signature-line" style={{
                  borderBottom: "1px solid #2d2d2d",
                  minWidth: "200px",
                  height: "30px"
                }}></div>
                <p style={{ 
                  marginTop: "5px", 
                  fontSize: "9pt",
                  color: primaryColor,
                  fontWeight: "600"
                }}>
                  {companyInfo.name.toUpperCase()}
                </p>
              </div>
            </div>

            {/* Enhanced Client Consent Section with Dynamic Brand Colors */}
            <div className="consent-section" style={{ 
              marginTop: "20px",
              padding: "12px",
              backgroundColor: "#fafafa",
              border: `1.5px solid ${primaryColor}`,
              borderRadius: "3px"
            }}>
              <p style={{
                fontWeight: "700",
                fontSize: "10pt",
                color: primaryColor,
                marginBottom: "8px",
                textTransform: "uppercase",
                letterSpacing: "0.5px"
              }}>
                CLIENT CONSENT & ACKNOWLEDGMENT
              </p>
              
              <p className="consent-text" style={{ 
                fontWeight: "400",
                marginBottom: "12px",
                fontSize: "9pt",
                lineHeight: 1.4,
                textAlign: "justify",
                color: "#2d2d2d"
              }}>
                I have read this letter and consent to it. Furthermore, I grant and give my informed consent after 
                <strong> {companyInfo.name}</strong> has proposed the course of conduct, has 
                communicated adequate information, and has explained all material risks of and reasonable available 
                alternatives to the proposed course of conduct.
              </p>

              <div className="signature-fields" style={{ 
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr",
                gap: "10px",
                marginTop: "15px",
                fontSize: "9pt"
              }}>
                <div>
                  <p style={{ 
                    marginBottom: "3px",
                    fontWeight: "600",
                    color: "#4a4a4a",
                    fontSize: "9pt"
                  }}>
                    Client Name:
                  </p>
                  <div className="signature-line" style={{
                    borderBottom: "1px solid #2d2d2d",
                    minWidth: "100%",
                    height: "25px"
                  }}></div>
                </div>
                <div>
                  <p style={{ 
                    marginBottom: "3px",
                    fontWeight: "600",
                    color: "#4a4a4a",
                    fontSize: "9pt"
                  }}>
                    Signature:
                  </p>
                  <div className="signature-line" style={{
                    borderBottom: "1px solid #2d2d2d",
                    minWidth: "100%",
                    height: "25px"
                  }}></div>
                </div>
                <div>
                  <p style={{ 
                    marginBottom: "3px",
                    fontWeight: "600",
                    color: "#4a4a4a",
                    fontSize: "9pt"
                  }}>
                    Date:
                  </p>
                  <div className="signature-line" style={{
                    borderBottom: "1px solid #2d2d2d",
                    minWidth: "100%",
                    height: "25px"
                  }}></div>
                </div>
              </div>
            </div>
          </div>
          {/* =================== END PROFESSIONAL LETTER =================== */}
        </Box>
      </DialogContent>

      <DialogActions className="no-print">
        <Button color="error" variant="outlined" onClick={props.onClose}>
          Close
        </Button>
        <Button 
          variant="contained" 
          color="primary" 
          onClick={handlePrint}
          startIcon={<PrintIcon />}
          disabled={companyLoading}
        >
          Print Document
        </Button>
      </DialogActions>
    </Dialog>
  );
}

// export function EngagementLetterModal(props) {
//   const theme = useTheme();
//   const colors = tokens(theme.palette.mode);
  
//   console.log("PROPS", props);

//   // Get client name from props, with fallbacks
//   const getClientName = () => {
//     if (!props.data) return "Client";
    
//     const { data } = props;
    
//     // Try different possible field names for first and last name
//     const firstName = data.firstName || data.firstname || data.clientFirstName || data.companyName ||  "";
//     const lastName = data.lastName || data.lastname || data.clientLastName || "";
    
//     // If we have both names, combine them
//     if (firstName && lastName) {
//       return `${firstName} ${lastName}`.toUpperCase();
//     }
    
//     // If we have only one name, use that
//     if (firstName || lastName) {
//       return (firstName || lastName).toUpperCase();
//     }
    
//     // Fallback to clientName or other fields
//     return data.clientName || data.name || "Client";
//   };

//   const clientName = getClientName();

//   const handlePrint = () => {
//     const printContent = document.getElementById("engagement-letter-print");
//     const printStyles = `
//       <style>
//         @media print {
//           body { 
//             margin: 0 !important; 
//             padding: 0 !important; 
//             font-family: 'Segoe UI', Arial, sans-serif !important;
//             font-size: 10pt !important;
//             line-height: 1.4 !important;
//             color: #2d2d2d !important;
//             -webkit-print-color-adjust: exact !important;
//             print-color-adjust: exact !important;
//           }
//           .print-container { 
//             padding: 15px 20px !important; 
//             max-width: 750px !important;
//             margin: 0 auto !important;
//             box-sizing: border-box !important;
//           }
//           .no-print { display: none !important; }
          
//           .logo-container img {
//             width: 80px !important;
//             height: 80px !important;
//             display: block;
//             margin: 0 auto 8px auto !important;
//           }
          
//           .header-section {
//             text-align: center !important;
//             margin-bottom: 15px !important;
//             padding-bottom: 10px !important;
//             border-bottom: 2px solid #6d1f1f !important;
//           }
          
//           .firm-name {
//             font-size: 12pt !important;
//             font-weight: 700 !important;
//             color: #6d1f1f !important;
//             letter-spacing: 0.5px !important;
//             margin-bottom: 5px !important;
//             line-height: 1.2 !important;
//           }
          
//           .contact-info {
//             font-size: 9pt !important;
//             color: #4a4a4a !important;
//             line-height: 1.3 !important;
//           }
          
//           .letter-content {
//             font-size: 10pt !important;
//             line-height: 1.4 !important;
//             color: #2d2d2d !important;
//           }
          
//           .letter-content p {
//             margin-bottom: 8px !important;
//             text-align: justify !important;
//           }
          
//           .date-section {
//             text-align: right !important;
//             margin-bottom: 15px !important;
//             font-size: 10pt !important;
//             color: #2d2d2d !important;
//           }
          
//           .subject-line {
//             font-weight: 700 !important;
//             color: #6d1f1f !important;
//             margin: 10px 0 !important;
//             font-size: 10pt !important;
//           }
          
//           .consent-section {
//             margin-top: 20px !important;
//             padding: 12px !important;
//             background-color: #fafafa !important;
//             border: 1.5px solid #6d1f1f !important;
//             border-radius: 3px !important;
//           }
          
//           .consent-text {
//             font-weight: 400 !important;
//             font-size: 9pt !important;
//             line-height: 1.4 !important;
//             color: #2d2d2d !important;
//             margin-bottom: 12px !important;
//           }
          
//           .signature-fields {
//             display: grid !important;
//             grid-template-columns: 1fr 1fr 1fr !important;
//             gap: 10px !important;
//             margin-top: 15px !important;
//             font-size: 9pt !important;
//           }
          
//           .signature-line {
//             border-bottom: 1px solid #2d2d2d !important;
//             display: inline-block !important;
//             min-width: 100% !important;
//             margin-left: 0 !important;
//             height: 25px !important;
//           }
          
//           * { 
//             box-sizing: border-box !important;
//             -webkit-print-color-adjust: exact !important;
//             print-color-adjust: exact !important;
//           }
          
//           @page {
//             margin: 0.5in !important;
//             size: letter portrait !important;
//           }

//           /* Force single page */
//           html, body {
//             height: auto !important;
//             overflow: hidden !important;
//           }
          
//           .print-container {
//             height: auto !important;
//             max-height: 10.5in !important;
//             overflow: hidden !important;
//           }
//         }
//       </style>
//     `;
    
//     const WinPrint = window.open("", "", "width=850,height=700");
//     WinPrint.document.write(`
//       <html>
//         <head>
//           <title>Engagement Letter - ${clientName}</title>
//           ${printStyles}
//         </head>
//         <body>
//           <div class="print-container">
//             ${printContent.innerHTML}
//           </div>
//         </body>
//       </html>
//     `);
//     WinPrint.document.close();
//     WinPrint.focus();
//     setTimeout(() => {
//       WinPrint.print();
//       WinPrint.close();
//     }, 500);
//   };

//   const now = new Date();
//   const day = now.getDate();
//   const month = now.toLocaleString("en-US", { month: "long" });
//   const year = now.getFullYear();

//   // Format date as "17th November, 2025"
//   const getOrdinalSuffix = (day) => {
//     if (day > 3 && day < 21) return 'th';
//     switch (day % 10) {
//       case 1: return "st";
//       case 2: return "nd";
//       case 3: return "rd";
//       default: return "th";
//     }
//   };

//   const formattedDate = `${day}${getOrdinalSuffix(day)} ${month}, ${year}`;

//   return (
//     <Dialog open={props.open} onClose={props.onClose} maxWidth="md" fullWidth>
//       <DialogTitle sx={{ color: colors.grey[100] }} className="no-print">
//         Engagement Letter - {clientName}
//       </DialogTitle>

//       <DialogContent>
//         <Box
//           id="engagement-letter-print"
//           sx={{
//             bgcolor: "#fff",
//             color: "#2d2d2d",
//             p: 3,
//             fontFamily: "'Segoe UI', Arial, sans-serif",
//             '@media print': {
//               p: 0,
//               m: 0,
//               boxShadow: 'none',
//               backgroundColor: 'white'
//             }
//           }}
//         >
//           {/* ===================== PROFESSIONAL LETTER FORMAT ===================== */}
//           <div className="letter-content" style={{ 
//             fontFamily: "'Segoe UI', Arial, sans-serif", 
//             lineHeight: 1.4,
//             maxWidth: '750px',
//             margin: '0 auto',
//             fontSize: '10pt',
//             color: '#2d2d2d'
//           }}>

//             {/* Header Section with Logo and Brand Colors */}
//             <div className="header-section" style={{ 
//               marginBottom: "15px", 
//               textAlign: "center",
//               paddingBottom: "10px",
//               borderBottom: "2px solid #6d1f1f"
//             }}>
//               {/* Logo Container */}
//               <div className="logo-container">
//                 <img 
//                   src={logo} 
//                   alt="Abdullahi Gitari & Odhiambo Advocates LLP"
//                   style={{
//                     width: "80px",
//                     height: "80px",
//                     objectFit: "contain",
//                     marginBottom: "8px",
//                     display: "block",
//                     marginLeft: "auto",
//                     marginRight: "auto"
//                   }}
//                   onError={(e) => {
//                     console.log("Logo failed to load, using fallback");
//                     e.target.style.display = 'none';
//                     // Create fallback element if it doesn't exist
//                     if (!e.target.nextSibling) {
//                       const fallback = document.createElement('div');
//                       fallback.style.cssText = `
//                         width: 80px; 
//                         height: 80px; 
//                         border: 1.5px solid #6d1f1f; 
//                         margin: 0 auto 8px; 
//                         font-size: 11px; 
//                         color: #6d1f1f; 
//                         text-align: center; 
//                         display: flex;
//                         align-items: center;
//                         justify-content: center;
//                         font-weight: 700;
//                         border-radius: 3px;
//                       `;
//                       fallback.textContent = 'AGO';
//                       e.target.parentNode.insertBefore(fallback, e.target.nextSibling);
//                     } else {
//                       e.target.nextSibling.style.display = 'flex';
//                     }
//                   }}
//                 />
//               </div>
              
//               <div className="firm-name" style={{ 
//                 fontSize: "12pt", 
//                 fontWeight: "700",
//                 color: "#6d1f1f",
//                 letterSpacing: "0.5px",
//                 marginBottom: "5px",
//                 lineHeight: "1.2"
//               }}>
//                 ABDULLAHI GITARI & ODHIAMBO ADVOCATES LLP
//               </div>
              
//               <div className="contact-info" style={{ 
//                 fontSize: "9pt", 
//                 color: "#4a4a4a", 
//                 lineHeight: 1.3 
//               }}>
//                 <div style={{ marginBottom: "2px" }}>P.O Box 29346 - 00100, Nairobi, Kenya</div>
//                 <div>Tel: +254 020 221 1122 / 100 211 122 | Email: info@agoadvocates.com</div>
//               </div>
//             </div>

//             {/* Date Section */}
//             <div className="date-section" style={{ 
//               marginBottom: "15px", 
//               textAlign: "right",
//               fontSize: "10pt",
//               color: "#2d2d2d"
//             }}>
//               <p style={{ margin: 0 }}>
//                 <strong>{formattedDate}</strong>
//               </p>
//             </div>

//             {/* Salutation */}
//             <p style={{ 
//               marginBottom: "10px", 
//               fontSize: "10pt",
//               color: "#2d2d2d" 
//             }}>
//               Dear <strong>{clientName}</strong>,
//             </p>

//             {/* Subject Line */}
//             <p className="subject-line" style={{ 
//               marginBottom: "10px",
//               fontWeight: "700",
//               fontSize: "10pt",
//               color: "#6d1f1f"
//             }}>
//               RE: REPRESENTATION BY ABDULLAHI GITARI & ODHIAMBO ADVOCATES LLP
//             </p>

//             {/* Letter Body Content */}
//             <div>
//               <p style={{ 
//                 textAlign: "justify", 
//                 marginBottom: "8px", 
//                 fontSize: "10pt",
//                 lineHeight: "1.4" 
//               }}>
//                 Thank you for consulting the firm of Abdullahi Gitari & Odhiambo Advocates LLP. Our primary objective will
//                 be to provide you with the best possible legal services available to deal with your legal matter.
//               </p>

//               <p style={{ 
//                 textAlign: "justify", 
//                 marginBottom: "8px", 
//                 fontSize: "10pt",
//                 lineHeight: "1.4" 
//               }}>
//                 We may send you pleadings, documents, correspondence, and other information throughout the case.
//                 These copies will be your file copies. Please retain them. We will also keep the information in a file in our
//                 office, which will be our file. Please bring your copy of the file to all of our meetings so that we both have
//                 all the necessary information in front of us. When we have completed all the legal work necessary for your
//                 case, we will close your file and return original documents to you.
//               </p>

//               <p style={{ 
//                 textAlign: "justify", 
//                 marginBottom: "8px", 
//                 fontSize: "10pt",
//                 lineHeight: "1.4" 
//               }}>
//                 We have included a copy of this letter for your review, signature, and return to us in the postage-paid
//                 envelope. If any of the information in this letter is not consistent with your understanding of our
//                 agreement, please contact Abdullahi Gitari & Odhiambo Advocates LLP before signing the letter.
//                 Otherwise, please sign the enclosed copy of this letter and return it to us.
//               </p>

//               <p style={{ 
//                 textAlign: "justify", 
//                 marginBottom: "8px", 
//                 fontSize: "10pt",
//                 lineHeight: "1.4" 
//               }}>
//                 On behalf of the firm, we are happy to represent you in this matter. If you have any questions, please
//                 contact us at your convenience.
//               </p>
//             </div>

//             {/* Closing */}
//             <p style={{ 
//               marginBottom: "5px", 
//               fontSize: "10pt",
//               marginTop: "15px" 
//             }}>
//               Very truly yours,
//             </p>

//             {/* Firm Signature Section */}
//             <div style={{ marginBottom: "20px", marginTop: "10px" }}>
//               <div style={{ 
//                 display: "inline-block",
//                 minWidth: "200px"
//               }}>
//                 <p style={{ 
//                   marginBottom: "2px", 
//                   fontSize: "9pt",
//                   color: "#4a4a4a",
//                   fontWeight: "600"
//                 }}>
//                   Advocate Signature:
//                 </p>
//                 <div className="signature-line" style={{
//                   borderBottom: "1px solid #2d2d2d",
//                   minWidth: "200px",
//                   height: "30px"
//                 }}></div>
//                 <p style={{ 
//                   marginTop: "5px", 
//                   fontSize: "9pt",
//                   color: "#6d1f1f",
//                   fontWeight: "600"
//                 }}>
//                   ABDULLAHI GITARI & ODHIAMBO ADVOCATES LLP
//                 </p>
//               </div>
//             </div>

//             {/* Enhanced Client Consent Section with Brand Colors */}
//             <div className="consent-section" style={{ 
//               marginTop: "20px",
//               padding: "12px",
//               backgroundColor: "#fafafa",
//               border: "1.5px solid #6d1f1f",
//               borderRadius: "3px"
//             }}>
//               <p style={{
//                 fontWeight: "700",
//                 fontSize: "10pt",
//                 color: "#6d1f1f",
//                 marginBottom: "8px",
//                 textTransform: "uppercase",
//                 letterSpacing: "0.5px"
//               }}>
//                 CLIENT CONSENT & ACKNOWLEDGMENT
//               </p>
              
//               <p className="consent-text" style={{ 
//                 fontWeight: "400",
//                 marginBottom: "12px",
//                 fontSize: "9pt",
//                 lineHeight: 1.4,
//                 textAlign: "justify",
//                 color: "#2d2d2d"
//               }}>
//                 I have read this letter and consent to it. Furthermore, I grant and give my informed consent after 
//                 <strong> Abdullahi Gitari & Odhiambo Advocates LLP</strong> has proposed the course of conduct, has 
//                 communicated adequate information, and has explained all material risks of and reasonable available 
//                 alternatives to the proposed course of conduct.
//               </p>

//               <div className="signature-fields" style={{ 
//                 display: "grid",
//                 gridTemplateColumns: "1fr 1fr 1fr",
//                 gap: "10px",
//                 marginTop: "15px",
//                 fontSize: "9pt"
//               }}>
//                 <div>
//                   <p style={{ 
//                     marginBottom: "3px",
//                     fontWeight: "600",
//                     color: "#4a4a4a",
//                     fontSize: "9pt"
//                   }}>
//                     Client Name:
//                   </p>
//                   <div className="signature-line" style={{
//                     borderBottom: "1px solid #2d2d2d",
//                     minWidth: "100%",
//                     height: "25px"
//                   }}></div>
//                 </div>
//                 <div>
//                   <p style={{ 
//                     marginBottom: "3px",
//                     fontWeight: "600",
//                     color: "#4a4a4a",
//                     fontSize: "9pt"
//                   }}>
//                     Signature:
//                   </p>
//                   <div className="signature-line" style={{
//                     borderBottom: "1px solid #2d2d2d",
//                     minWidth: "100%",
//                     height: "25px"
//                   }}></div>
//                 </div>
//                 <div>
//                   <p style={{ 
//                     marginBottom: "3px",
//                     fontWeight: "600",
//                     color: "#4a4a4a",
//                     fontSize: "9pt"
//                   }}>
//                     Date:
//                   </p>
//                   <div className="signature-line" style={{
//                     borderBottom: "1px solid #2d2d2d",
//                     minWidth: "100%",
//                     height: "25px"
//                   }}></div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           {/* =================== END PROFESSIONAL LETTER =================== */}
//         </Box>
//       </DialogContent>

//       <DialogActions className="no-print">
//         <Button color="error" variant="outlined" onClick={props.onClose}>
//           Close
//         </Button>
//         <Button 
//           variant="contained" 
//           color="primary" 
//           onClick={handlePrint}
//           startIcon={<PrintIcon />}
//         >
//           Print Document
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// }


export function CourtAttendanceSheetModal(props) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [attendanceData, setAttendanceData] = useState(null);
  const [courtData, setCourtData] = useState(null);
  const [loading, setLoading] = useState(false);

  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const companyId = decodedToken ? parseInt(decodedToken.CompanyId) : null;

  // ---- Company / logo / brand color state, same as EngagementLetterModal ----
  const [companyData, setCompanyData] = useState(null);
  const [companyLoading, setCompanyLoading] = useState(true);
  const [logoUrl, setLogoUrl] = useState(null);
  const [logoLoadFailed, setLogoLoadFailed] = useState(false);
  const [brandColors, setBrandColors] = useState(DEFAULT_COLORS);

  // Fetch court attendance data when modal opens
  useEffect(() => {
    if (props.open && props.data?.id) {
      fetchCourtAttendanceData();
    }
  }, [props.open, props.data?.id]);

  // ---- Fetch company details + derive logo/brand colors ----
  useEffect(() => {
    const fetchCompanyData = async () => {
      try {
        setCompanyLoading(true);

        const companyQuery = `
          {
          allCompanies {
                id
                companyName
                companyEmail
                contactEmail
                contactEmailPassword
                emailDisplayName
                emailClient
                emailClientPortNumber
                subscriptionId
                createdBy
                createdDate
                updatedBy
                updatedDate
                logoPath
                address
                poBox
                phone
                mobile
                website
                pinVat
                tagline
            }
        }
        `;

        const response = await graphqlQuery(
          companyQuery,
          companyManagementUrl.uri,
        );

        if (response && response.length > 0) {
          const company = response.find((c) => c.id === companyId) || response[0];
          setCompanyData(company);

          const normalizedLogoUrl = normalizeLogoPath(company.logoPath);
          setLogoUrl(normalizedLogoUrl);
          setLogoLoadFailed(false);

          if (normalizedLogoUrl) {
            const extracted = await extractColorsFromImage(normalizedLogoUrl);
            setBrandColors(extracted);
          } else {
            setBrandColors(DEFAULT_COLORS);
          }
        }
      } catch (err) {
        console.error("Error fetching company data:", err);
        setBrandColors(DEFAULT_COLORS);
      } finally {
        setCompanyLoading(false);
      }
    };

    if (props.open) {
      fetchCompanyData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.open]);

  const companyInfo = {
    name: companyData?.companyName || "set at company management",
    address: companyData?.address || "set at company management",
    poBox: companyData?.poBox || "set at company management",
    phone: companyData?.phone || "set at company management",
    mobile: companyData?.mobile || "set at company management",
    email: companyData?.companyEmail || "set at company management",
    website: companyData?.website || "set at company management",
    pinVat: companyData?.pinVat || "set at company management",
    tagline: companyData?.tagline || "set at company management",
  };

  const primaryColor = brandColors.primary;
  const secondaryColor = brandColors.secondary;
  const primaryText = readableTextColor(primaryColor);

  const resolvedLogoSrc = logoUrl && !logoLoadFailed ? logoUrl : logo;
  const handleLogoError = () => setLogoLoadFailed(true);

  const fetchCourtAttendanceData = async () => {
    setLoading(true);
    try {
      const query = `
        query AllCourtAttendanceView {
          allCourtAttendanceView {
            id
            fileId
            caseTitle
            fileNo
            caseNumber
            companyId
            court
            courtDate
            judgeName
            appearanceType
            advocatePresent
            advocateName
            petitioner
            defendant
            outcome
            nextOption
            nextOptionDate
            nextAction
            nextActionReminderPeriod
            purposeOfAttendance
            createdBy
            createdDate
            updatedBy
            updatedDate
          }
        }
      `;

      console.log("Fetching court attendance data for fileId:", props.data.id);

      const result = await graphqlQuery(
        query,
        caseManagementUrl.uri
      );

      console.log("Raw GraphQL result:", result);

      let attendanceRecords = result;

      if (result && result.allCourtAttendanceView) {
        attendanceRecords = result.allCourtAttendanceView;
      } else if (Array.isArray(result)) {
        attendanceRecords = result;
      } else {
        console.log("Unexpected response format:", result);
        attendanceRecords = [];
      }

      console.log("Processed attendance records:", attendanceRecords);
      console.log("Total records received:", attendanceRecords.length);

      const matchingRecords = attendanceRecords.filter(
        record => parseInt(record.fileId) === parseInt(props.data.id)
      );

      console.log("Matching records for fileId", props.data.id, ":", matchingRecords);

      if (matchingRecords.length > 0) {
        const sortedRecords = matchingRecords.sort((a, b) =>
          new Date(b.createdDate) - new Date(a.createdDate)
        );

        const mostRecentRecord = sortedRecords[0];
        console.log("Selected most recent record:", mostRecentRecord);

        setAttendanceData(mostRecentRecord);

        if (mostRecentRecord.court) {
          fetchCourtDetails(mostRecentRecord.court);
        }
      } else {
        console.log("No records found with fileId:", props.data.id);
        console.log("Available fileIds:", [...new Set(attendanceRecords.map(r => r.fileId))]);
      }
    } catch (error) {
      console.error("Error fetching court attendance data:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchCourtDetails = async (courtName) => {
    try {
      const courtsQuery = `
        {
          allCourts {
            id
            court
            courtType
            county
            subCounty
          }
        }
      `;

      const courtResult = await graphqlQuery(
        courtsQuery,
        setupManagement.uri
      );

      if (courtResult?.allCourts) {
        const court = courtResult.allCourts.find(c => c.court === courtName);
        if (court) {
          setCourtData(court);
        } else {
          console.log("Court not found in setup management:", courtName);
        }
      }
    } catch (error) {
      console.error("Error fetching court details:", error);
    }
  };

  const handlePrint = () => {
    const printContent = document.getElementById("court-attendance-print");
    const printStyles = `
      <style>
        @media print {
          body { 
            margin: 0 !important; 
            padding: 0 !important; 
            font-family: 'Segoe UI', Arial, sans-serif !important;
            font-size: 10pt !important;
            line-height: 1.3 !important;
            color: #2d2d2d !important;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
          .print-container { 
            padding: 15px 20px !important; 
            width: 100% !important;
            max-width: 750px !important;
            margin: 0 auto !important;
            box-sizing: border-box !important;
          }
          .no-print { display: none !important; }
          
          .logo-container img {
            width: 70px !important;
            height: 70px !important;
            display: block;
            margin: 0 auto 6px auto !important;
          }

          /* Header with Logo Space */
          .header-section {
            text-align: center !important;
            margin-bottom: 15px !important;
            padding-bottom: 10px !important;
            border-bottom: 2px solid ${primaryColor} !important;
            page-break-inside: avoid !important;
          }
          
          .firm-name {
            font-size: 16pt !important;
            font-weight: 700 !important;
            color: ${primaryColor} !important;
            letter-spacing: 0.5px !important;
            margin-bottom: 3px !important;
            line-height: 1.2 !important;
          }
          
          .document-title {
            font-size: 14pt !important;
            font-weight: 700 !important;
            color: #2d2d2d !important;
            letter-spacing: 1px !important;
            margin-top: 5px !important;
            text-transform: uppercase !important;
            line-height: 1.2 !important;
          }

          /* Compact Layout */
          .detail-row {
            display: grid !important;
            grid-template-columns: 150px 1fr !important;
            margin-bottom: 6px !important;
            align-items: start !important;
            page-break-inside: avoid !important;
            font-size: 9.5pt !important;
          }
          
          .detail-label {
            font-weight: 600 !important;
            color: #4a4a4a !important;
            font-size: 9.5pt !important;
          }

          .detail-value {
            font-weight: 400 !important;
            color: #2d2d2d !important;
            word-break: break-word !important;
            font-size: 9.5pt !important;
          }
          
          .detail-value strong {
            font-weight: 600 !important;
            color: #1a1a1a !important;
          }

          .two-column-section {
            display: grid !important;
            grid-template-columns: 1fr 1fr !important;
            gap: 15px !important;
            margin-bottom: 12px !important;
            page-break-inside: avoid !important;
          }
          
          .column {
            display: flex !important;
            flex-direction: column !important;
            gap: 6px !important;
          }

          /* Boxed Sections with Brand Colors */
          .attendance-section,
          .proceedings-section,
          .next-action-section {
            margin: 12px 0 !important;
            padding: 12px !important;
            border: 1.5px solid ${primaryColor} !important;
            border-radius: 3px !important;
            background-color: #fafafa !important;
            page-break-inside: avoid !important;
          }
          
          .section-title {
            font-weight: 700 !important;
            font-size: 11pt !important;
            color: ${primaryColor} !important;
            margin-bottom: 8px !important;
            text-transform: uppercase !important;
            letter-spacing: 0.5px !important;
          }
          
          .proceedings-content {
            text-align: justify !important;
            min-height: 60px !important;
            max-height: 80px !important;
            padding: 8px !important;
            background-color: white !important;
            border: 1px solid #ddd !important;
            border-radius: 2px !important;
            font-size: 9.5pt !important;
            line-height: 1.4 !important;
            overflow: hidden !important;
          }
          
          /* Signature Section */
          .signature-section {
            margin-top: 25px !important;
            page-break-inside: avoid !important;
          }
          
          .signature-line {
            border-top: 1px solid #2d2d2d !important;
            width: 200px !important;
            margin-left: auto !important;
            padding-top: 5px !important;
            text-align: center !important;
            font-size: 9.5pt !important;
            color: #4a4a4a !important;
          }

          /* Full width sections */
          .full-width-section {
            grid-template-columns: 150px 1fr !important;
            margin-bottom: 12px !important;
          }

          * { 
            box-sizing: border-box !important;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
          
          @page {
            margin: 0.5in !important;
            size: letter portrait !important;
          }

          /* Force single page */
          html, body {
            height: auto !important;
            overflow: hidden !important;
          }
          
          .print-container {
            height: auto !important;
            max-height: 10.5in !important;
            overflow: hidden !important;
          }
        }
      </style>
    `;

    const WinPrint = window.open("", "", "width=850,height=700");
    WinPrint.document.write(`
      <html>
        <head>
          <title>Court Attendance Sheet - ${attendanceData?.caseNumber || 'Case'}</title>
          ${printStyles}
        </head>
        <body>
          <div class="print-container">
            ${printContent.innerHTML}
          </div>
        </body>
      </html>
    `);
    WinPrint.document.close();
    WinPrint.focus();
    setTimeout(() => {
      WinPrint.print();
      WinPrint.close();
    }, 500);
  };

  // Format date from "2024-03-15" to "15th March 2024"
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;

    const day = date.getDate();
    const suffix = ['th', 'st', 'nd', 'rd'][day % 10 > 3 ? 0 : (day % 100 - day % 10 != 10) * day % 10];
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
                       'July', 'August', 'September', 'October', 'November', 'December'];

    return `${day}${suffix} ${monthNames[date.getMonth()]} ${date.getFullYear()}`;
  };

  if (loading || companyLoading) {
    return (
      <Dialog open={props.open} onClose={props.onClose} maxWidth="md" fullWidth>
        <DialogContent>
          <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
            <Typography>Loading court attendance data...</Typography>
          </Box>
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Dialog open={props.open} onClose={props.onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ color: colors.grey[100] }} className="no-print">
        Court Attendance Sheet - {attendanceData?.caseNumber || 'Case'}
      </DialogTitle>

      <DialogContent>
        <Box
          id="court-attendance-print"
          sx={{
            bgcolor: "#fff",
            color: "#2d2d2d",
            p: 3,
            fontFamily: "'Segoe UI', Arial, sans-serif",
            lineHeight: 1.4,
            maxWidth: '750px',
            margin: '0 auto',
            fontSize: '11pt',
            '@media print': {
              p: 0,
              m: 0,
              boxShadow: 'none',
              backgroundColor: 'white'
            }
          }}
        >
          <div style={{ lineHeight: 1.4 }}>

            {/* Header Section */}
            <div className="header-section" style={{
              textAlign: 'center',
              marginBottom: '15px',
              borderBottom: `2px solid ${primaryColor}`,
              paddingBottom: '10px'
            }}>
              {/* Logo */}
              <div className="logo-container">
                <img
                  src={resolvedLogoSrc}
                  alt={companyInfo.name}
                  style={{
                    width: "70px",
                    height: "70px",
                    objectFit: "contain",
                    marginBottom: "6px",
                    display: "block",
                    marginLeft: "auto",
                    marginRight: "auto"
                  }}
                  onError={handleLogoError}
                />
              </div>

              <div className="firm-name" style={{ 
                fontSize: '16pt', 
                fontWeight: '700', 
                color: primaryColor,
                letterSpacing: '0.5px',
                marginBottom: '3px',
                lineHeight: '1.2'
              }}>
                {companyInfo.name.toUpperCase()}
              </div>
              <div className="document-title" style={{ 
                fontSize: '14pt', 
                fontWeight: '700', 
                color: '#2d2d2d',
                letterSpacing: '1px',
                marginTop: '5px',
                textTransform: 'uppercase',
                lineHeight: '1.2'
              }}>
                COURT ATTENDANCE SHEET
              </div>
            </div>

            {/* Two Column Layout for Case Details */}
            <div className="two-column-section" style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: '15px',
              marginBottom: '12px'
            }}>
              <div className="column" style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <div className="detail-row" style={{ display: 'grid', gridTemplateColumns: '150px 1fr', marginBottom: '6px', alignItems: 'start' }}>
                  <div className="detail-label" style={{ fontWeight: '600', color: '#4a4a4a', fontSize: '9.5pt' }}>Date:</div>
                  <div className="detail-value" style={{ fontWeight: '400', wordBreak: 'break-word', fontSize: '9.5pt' }}>
                    <strong>{attendanceData?.courtDate ? formatDate(attendanceData.courtDate) : ''}</strong>
                  </div>
                </div>

                <div className="detail-row" style={{ display: 'grid', gridTemplateColumns: '150px 1fr', marginBottom: '6px', alignItems: 'start' }}>
                  <div className="detail-label" style={{ fontWeight: '600', color: '#4a4a4a', fontSize: '9.5pt' }}>Court:</div>
                  <div className="detail-value" style={{ fontWeight: '400', wordBreak: 'break-word', fontSize: '9.5pt' }}>
                    <strong>{attendanceData?.court || ''}</strong>
                  </div>
                </div>
              </div>

              <div className="column" style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <div className="detail-row" style={{ display: 'grid', gridTemplateColumns: '150px 1fr', marginBottom: '6px', alignItems: 'start' }}>
                  <div className="detail-label" style={{ fontWeight: '600', color: '#4a4a4a', fontSize: '9.5pt' }}>Judge/Magistrate:</div>
                  <div className="detail-value" style={{ fontWeight: '400', wordBreak: 'break-word', fontSize: '9.5pt' }}>
                    <strong>{attendanceData?.judgeName || ''}</strong>
                  </div>
                </div>

                <div className="detail-row" style={{ display: 'grid', gridTemplateColumns: '150px 1fr', marginBottom: '6px', alignItems: 'start' }}>
                  <div className="detail-label" style={{ fontWeight: '600', color: '#4a4a4a', fontSize: '9.5pt' }}>Case Number:</div>
                  <div className="detail-value" style={{ fontWeight: '400', wordBreak: 'break-word', fontSize: '9.5pt' }}>
                    <strong>{attendanceData?.caseNumber || ''}</strong>
                  </div>
                </div>
              </div>
            </div>

            {/* Case Title - Full Width */}
            <div className="detail-row full-width-section" style={{ display: 'grid', gridTemplateColumns: '150px 1fr', marginBottom: '12px', alignItems: 'start' }}>
              <div className="detail-label" style={{ fontWeight: '600', color: '#4a4a4a', fontSize: '9.5pt' }}>Case Title:</div>
              <div className="detail-value" style={{ fontWeight: '400', wordBreak: 'break-word', fontSize: '9.5pt' }}>
                <strong>{attendanceData?.caseTitle || ''}</strong>
              </div>
            </div>

            {/* Additional Details - Compact Row */}
            <div className="two-column-section" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '12px' }}>
              <div className="column" style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <div className="detail-row" style={{ display: 'grid', gridTemplateColumns: '150px 1fr', marginBottom: '6px', alignItems: 'start' }}>
                  <div className="detail-label" style={{ fontWeight: '600', color: '#4a4a4a', fontSize: '9.5pt' }}>File Number:</div>
                  <div className="detail-value" style={{ fontWeight: '400', wordBreak: 'break-word', fontSize: '9.5pt' }}>
                    {attendanceData?.fileNo || ''}
                  </div>
                </div>
              </div>

              <div className="column" style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <div className="detail-row" style={{ display: 'grid', gridTemplateColumns: '150px 1fr', marginBottom: '6px', alignItems: 'start' }}>
                  <div className="detail-label" style={{ fontWeight: '600', color: '#4a4a4a', fontSize: '9.5pt' }}>Appearance Type:</div>
                  <div className="detail-value" style={{ fontWeight: '400', wordBreak: 'break-word', fontSize: '9.5pt' }}>
                    {attendanceData?.appearanceType || ''}
                  </div>
                </div>
              </div>
            </div>

            {/* Attendance Section */}
            <div className="attendance-section" style={{ margin: '12px 0', padding: '12px', border: `1.5px solid ${primaryColor}`, borderRadius: '3px', backgroundColor: '#fafafa' }}>
              <div className="section-title" style={{ fontWeight: '700', fontSize: '11pt', color: primaryColor, marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                In Attendance
              </div>

              <div className="two-column-section" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '8px' }}>
                <div className="column" style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                  <div className="detail-row" style={{ display: 'grid', gridTemplateColumns: '150px 1fr', marginBottom: '6px', alignItems: 'start' }}>
                    <div className="detail-label" style={{ fontWeight: '600', color: '#4a4a4a', fontSize: '9.5pt' }}>Plaintiff/Petitioner:</div>
                    <div className="detail-value" style={{ fontWeight: '400', wordBreak: 'break-word', fontSize: '9.5pt' }}>
                      {attendanceData?.petitioner || ''}
                    </div>
                  </div>
                </div>

                <div className="column" style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                  <div className="detail-row" style={{ display: 'grid', gridTemplateColumns: '150px 1fr', marginBottom: '6px', alignItems: 'start' }}>
                    <div className="detail-label" style={{ fontWeight: '600', color: '#4a4a4a', fontSize: '9.5pt' }}>Defendant/Respondent:</div>
                    <div className="detail-value" style={{ fontWeight: '400', wordBreak: 'break-word', fontSize: '9.5pt' }}>
                      {attendanceData?.defendant || ''}
                    </div>
                  </div>
                </div>
              </div>

              <div className="detail-row full-width-section" style={{ display: 'grid', gridTemplateColumns: '150px 1fr', marginBottom: '0', alignItems: 'start' }}>
                <div className="detail-label" style={{ fontWeight: '600', color: '#4a4a4a', fontSize: '9.5pt' }}>Advocate Present:</div>
                <div className="detail-value" style={{ fontWeight: '400', wordBreak: 'break-word', fontSize: '9.5pt' }}>
                  <strong>{attendanceData?.advocateName || ''}</strong>
                </div>
              </div>
            </div>

            {/* Purpose of Attendance */}
            <div className="detail-row full-width-section" style={{ display: 'grid', gridTemplateColumns: '150px 1fr', marginBottom: '12px', alignItems: 'start' }}>
              <div className="detail-label" style={{ fontWeight: '600', color: '#4a4a4a', fontSize: '9.5pt' }}>Purpose of Attendance:</div>
              <div className="detail-value" style={{ fontWeight: '400', wordBreak: 'break-word', fontSize: '9.5pt' }}>
                <strong>{attendanceData?.purposeOfAttendance || ''}</strong>
              </div>
            </div>

            {/* Proceedings & Progress Section */}
            <div className="proceedings-section" style={{ margin: '12px 0', padding: '12px', border: `1.5px solid ${primaryColor}`, borderRadius: '3px', backgroundColor: '#fafafa' }}>
              <div className="section-title" style={{ fontWeight: '700', fontSize: '11pt', color: primaryColor, marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                Proceedings & Progress
              </div>
              <div className="proceedings-content" style={{ textAlign: 'justify', minHeight: '60px', maxHeight: '80px', padding: '8px', backgroundColor: 'white', border: '1px solid #ddd', borderRadius: '2px', fontSize: '9.5pt', lineHeight: '1.4', overflow: 'hidden' }}>
                {attendanceData?.outcome || ''}
              </div>
            </div>

            {/* Next Action Section */}
            <div className="next-action-section" style={{ margin: '12px 0', padding: '12px', border: `1.5px solid ${primaryColor}`, borderRadius: '3px', backgroundColor: '#fafafa' }}>
              <div className="section-title" style={{ fontWeight: '700', fontSize: '11pt', color: primaryColor, marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                Next Action & Follow-Up
              </div>

              <div className="two-column-section" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '0' }}>
                <div className="column" style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                  <div className="detail-row" style={{ display: 'grid', gridTemplateColumns: '150px 1fr', marginBottom: '6px', alignItems: 'start' }}>
                    <div className="detail-label" style={{ fontWeight: '600', color: '#4a4a4a', fontSize: '9.5pt' }}>Next Action:</div>
                    <div className="detail-value" style={{ fontWeight: '400', wordBreak: 'break-word', fontSize: '9.5pt' }}>
                      {attendanceData?.nextAction || ''}
                    </div>
                  </div>

                  <div className="detail-row" style={{ display: 'grid', gridTemplateColumns: '150px 1fr', marginBottom: '6px', alignItems: 'start' }}>
                    <div className="detail-label" style={{ fontWeight: '600', color: '#4a4a4a', fontSize: '9.5pt' }}>Next Option:</div>
                    <div className="detail-value" style={{ fontWeight: '400', wordBreak: 'break-word', fontSize: '9.5pt' }}>
                      {attendanceData?.nextOption || ''}
                    </div>
                  </div>
                </div>

                <div className="column" style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                  <div className="detail-row" style={{ display: 'grid', gridTemplateColumns: '150px 1fr', marginBottom: '6px', alignItems: 'start' }}>
                    <div className="detail-label" style={{ fontWeight: '600', color: '#4a4a4a', fontSize: '9.5pt' }}>Next Option Date:</div>
                    <div className="detail-value" style={{ fontWeight: '400', wordBreak: 'break-word', fontSize: '9.5pt' }}>
                      {attendanceData?.nextOptionDate ? formatDate(attendanceData.nextOptionDate) : ''}
                    </div>
                  </div>

                  <div className="detail-row" style={{ display: 'grid', gridTemplateColumns: '150px 1fr', marginBottom: '6px', alignItems: 'start' }}>
                    <div className="detail-label" style={{ fontWeight: '600', color: '#4a4a4a', fontSize: '9.5pt' }}>Reminder Period:</div>
                    <div className="detail-value" style={{ fontWeight: '400', wordBreak: 'break-word', fontSize: '9.5pt' }}>
                      {attendanceData?.nextActionReminderPeriod || ''}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Signature Section */}
            <div className="signature-section" style={{ marginTop: '25px' }}>
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '3px', alignItems: 'center' }}>
                <div style={{ fontWeight: '600', color: '#4a4a4a', fontSize: '9.5pt', marginRight: '8px' }}>Advocate:</div>
                <div style={{ fontWeight: '600', fontSize: '9.5pt', color: '#1a1a1a' }}>
                  {attendanceData?.advocateName || ''}
                </div>
              </div>
              <div className="signature-line" style={{ borderTop: '1px solid #2d2d2d', width: '200px', marginLeft: 'auto', paddingTop: '5px', textAlign: 'center', fontSize: '9.5pt', color: '#4a4a4a' }}>
                Signature: ____________________
              </div>
            </div>

          </div>
        </Box>
      </DialogContent>

      <DialogActions className="no-print">
        <Button color="error" variant="outlined" onClick={props.onClose}>
          Close
        </Button>
        <Button 
          variant="contained" 
          color="primary" 
          onClick={handlePrint}
          startIcon={<PrintIcon />}
          disabled={!attendanceData || companyLoading}
        >
          Print Document
        </Button>
      </DialogActions>
    </Dialog>
  );
}
export function UpdateCaseStatusModal(props) {
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const caseId = JSON.parse(localStorage.getItem("CaseId"));
  const base_url = caseManagementUrl.uri;
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  async function fetchData() {
    try {
      const response = await graphqlQuery(allCaseStatus, base_url);

      if (response) setData(response);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  }

  React.useEffect(() => {
    fetchData();
  }, []);

  const usersOptions = data
    ? data.map((data) => ({
        parent_key: data.id,
        value: data.id,
        label: data.status,
      }))
    : [];

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const { statusId } = values;
      const userIdFromSession = JSON.parse(
        localStorage.getItem("decodedToken")
      ).Id;

      const mutationData = {
        caseId: props.data.id,
        flag: statusId,
      };

      const response = await generateAndExecuteMutation(
        "updateCaseStatus",
        mutationData,
        "statusParams",
        base_url
      );

      if (Object.values(response)[0] != null) {
        props.onClose();
        props.onAction();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Case status Updated Successfully.`,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }
    setSubmitting(false);
    props.onClose();
  };

  return (
    <React.Fragment>
      <Dialog open={props.open} onClose={props.onClose}>
        <DialogTitle sx={{ color: colors.grey[100] }}>
          Update Case Status
        </DialogTitle>
        <Formik
          initialValues={{ statusId: props.data.statusFlag }}
          // validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
            setFieldValue,
            isSubmitting,
          }) => (
            <form onSubmit={handleSubmit}>
              <DialogContent>
                <DialogContentText sx={{ color: colors.greenAccent[400] }}>
                  Select a case status
                </DialogContentText>
                <Autocomplete
                  options={usersOptions}
                  getOptionLabel={(option) => option.label}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Status"
                      variant="filled"
                      onBlur={handleBlur}
                      error={touched.statusId && !!errors.statusId}
                      helperText={touched.statusId && errors.statusId}
                    />
                  )}
                  onChange={(event, newValue) => {
                    setFieldValue("statusId", newValue ? newValue.value : "");
                  }}
                />
              </DialogContent>
              <DialogActions>
                <Button
                  color="error"
                  variant="outlined"
                  onClick={props.onClose}
                >
                  Cancel
                </Button>
                <Button
                  variant="outlined"
                  type="submit"
                  disabled={isSubmitting}
                  color="success"
                >
                  {isSubmitting ? "updating..." : "Update Status"}
                </Button>
              </DialogActions>
            </form>
          )}
        </Formik>
      </Dialog>
    </React.Fragment>
  );
}
export function MarkPaid(props) {
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const caseId = JSON.parse(localStorage.getItem("CaseId"));
  const base_url = caseManagementUrl.uri;
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const mutationData = {
        caseId: caseId,
        newProcessWorkFlow: 5,
        amount: parseInt(values.amount),
      };

      const response = await generateAndExecuteMutation(
        "updateCaseProcessWorkFlow",
        mutationData,
        "workFlowInput",
        base_url
      );

      if (Object.values(response)[0] != null) {
        props.onClose();
        props.onAction();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Invoice marked as paid successfully.`,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }
    setSubmitting(false);
    props.onClose();
  };

  return (
    <React.Fragment>
      <Dialog open={props.open} onClose={props.onClose}>
        <DialogTitle sx={{ color: colors.grey[100] }}>Mark Paid</DialogTitle>
        <Formik
          initialValues={{ amount: "" }}
          // validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
            setFieldValue,
            isSubmitting,
          }) => (
            <form onSubmit={handleSubmit}>
              <DialogContent>
                <DialogContentText sx={{ color: colors.greenAccent[400] }}>
                  Enter Amount
                </DialogContentText>
                <TextField
                  fullWidth
                  variant="filled"
                  type="number"
                  label="Amount *"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.amount}
                  name="amount"
                  // error={touched.caseNumber && !!errors.caseNumber}
                  // helperText={touched.caseNumber && errors.caseNumber}
                  // sx={{ gridColumn: "span 2" }}
                />
              </DialogContent>
              <DialogActions>
                <Button
                  color="error"
                  variant="outlined"
                  onClick={props.onClose}
                >
                  Cancel
                </Button>
                <Button
                  variant="outlined"
                  type="submit"
                  disabled={isSubmitting}
                  color="success"
                >
                  {isSubmitting ? "Marking Paid..." : "Mark Paid"}
                </Button>
              </DialogActions>
            </form>
          )}
        </Formik>
      </Dialog>
    </React.Fragment>
  );
}
export function DocumentAccessModal(props) {
  const [documentAccess, setDocumentAccess] = React.useState([]);
  const [documentById, setDocumentById] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const documentUrl = documentManagementUrl.uri;
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const UserId = parseInt(decodedToken.Id);
  const companyId = parseInt(decodedToken.CompanyId);


  const cleanJsonString = (jsonString) => {
    const parsedData = JSON.parse(jsonString);
    const cleanUsers = parsedData.users.map((user) => ({
      ...user,
      permissions: JSON.parse(user.permissions),
    }));
    return { ...parsedData, users: cleanUsers };
  };
  const cleanJson = (jsonString) => {
    const parsedData = JSON.parse(jsonString);
    const cleanUsers = parsedData.Users.map((user) => ({
      ...user,
      permissions: JSON.parse(user.permissions),
    }));
    return { ...parsedData, users: cleanUsers };
  };
//  useEffect(() => {
//    async function fetchAllData() {
//      try {
//        const returnFields = ["id", "processWorkFlow"];
//        const inputFields = { id: caseId };
//        const Facts = await fetchDataEngine(
//          "userById",
//          null,
//          inputFields,
//          returnFields,
//          base_url
//        );
//        setCaseData(Facts);
//      } catch (error) {
//        console.error("Error fetching data:", error);
//      } finally {
//        setLoading(false);
//      }
//    }
//    fetchAllData();
//  }, []);
  const fetchDocumentData = async () => {
    const documentId = props.data.id;
    try {
      const data = await getDocumentAccessPermissions(documentId, documentUrl);
      const cleanedData =cleanJson(data)
      setDocumentAccess(cleanedData.users);

      const dataById = await getDocumentAccessPermissionsById(
        documentId,
        documentUrl
      );
      const cleanedDataById = cleanJsonString(dataById);
      setDocumentById(cleanedDataById.users);
    } catch (error) {
      console.error("Error fetching document data:", error);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    fetchDocumentData();
  }, []);

  const validationSchema = yup.object().shape({
    permissions: yup.object().required("Permissions are required"),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const mutationData = Object.keys(values.permissions).map((userId) => ({
        documentId: props.data.id,
        userId: UserId,
        readRight: values.permissions[userId].ReadRight,
        downloadRight: values.permissions[userId].DownloadRight,
        editRight: values.permissions[userId].EditRight,
        deleteRight: values.permissions[userId].DeleteRight,
        companyId: companyId,
        active: true,
      }));

      const response = await generateAndExecuteBulkMutation(
        "createAccessBulk",
        "accessList",
        mutationData,

        documentManagementUrl.uri
      );

      if (Object.values(response)[0] != null) {
        props.onClose();
        props.onAction();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Document rights have been assigned successfully.`,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }
    setSubmitting(false);
    props.onClose();
  };

  const initialValues = {
    permissions: documentAccess.reduce((acc, user) => {
      const userDoc = documentById.find((doc) => doc.userId === user.userId);
      acc[user.userId] = userDoc
        ? userDoc.permissions
        : {
            ReadRight: false,
            DownloadRight: false,
            EditRight: false,
            DeleteRight: false,
          };
      return acc;
    }, {}),
  };

  return (
    <React.Fragment>
      <Dialog open={props.open} onClose={props.onClose}>
        <DialogTitle sx={{ color: colors.grey[100] }}>
          Assign Permissions
        </DialogTitle>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({
            values,
            handleBlur,
            handleChange,
            handleSubmit,
            setFieldValue,
            isSubmitting,
          }) => (
            <form onSubmit={handleSubmit}>
            <DialogContent>
              <DialogContentText sx={{ color: colors.greenAccent[400] }}>
                Assign Privileges to team members
              </DialogContentText>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  m: "auto",
                  width: "fit-content",
                }}
              >
                {documentAccess.map((user) => (
                  <div key={user.userId}>
                    <Typography color={colors.greenAccent[400]}>
                      {user.UserName}
                    </Typography>
                    {[
                      "ReadRight",
                      "EditRight",
                      "DeleteRight",
                      "DownloadRight",
                    ].map((right) => (
                      <FormControlLabel
                        key={`${user.userId}-${right}`} // Unique key for each checkbox
                        control={
                          <Checkbox
                            checked={
                              values.permissions[user.userId]
                                ? values.permissions[user.userId][right]
                                : false
                            }
                            onChange={(event) => {
                              setFieldValue(
                                `permissions.${user.userId}.${right}`,
                                event.target.checked
                              );
                            }}
                            name={`permissions.${user.userId}.${right}`}
                            color="primary"
                          />
                        }
                        label={`Can ${right.replace("Right", "")}`}
                      />
                    ))}
                  </div>
                ))}
              </Box>
            </DialogContent>
            <DialogActions>
              <Button color="error" variant="outlined" onClick={props.onClose}>
                Cancel
              </Button>
              <Button
                variant="outlined"
                type="submit"
                disabled={isSubmitting}
                color="success"
              >
                {isSubmitting ? "Assigning..." : "Assign Access"}
              </Button>
            </DialogActions>
          </form>
          
          )}
        </Formik>
      </Dialog>
    </React.Fragment>
  );
}


export function UploadDocumentComponent(props) {
  const { uploadType, open, onClose } = props;
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [uploadedDocuments, setUploadedDocuments] = useState([]);

  const validationSchema = yup.object().shape({
    document: yup.mixed().required('Document is required'),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const mutationNames = {
        case: uploadCasefile,
        individual: uploadCaseForClientfile,
        corporate: uploadCaseForClientfile,
        individualClient: uploadIndividualClient,
        corporateClients: uploadCorporateClient
      };
      const mutationName = mutationNames[uploadType];

      let response;
      if (uploadType === 'case' || uploadType === 'individualClient' || uploadType === 'corporateClients') {
        response = await mutationName(values.document);
      } else {
        let ClientType;
        let ClientId;
        if (uploadType === 'individual') {
          ClientType = 1;
          ClientId = JSON.parse(localStorage.getItem("IndividualclientData")).id;
        } else {
          ClientType = 2;
          ClientId = JSON.parse(localStorage.getItem("CorporateclientData")).id;
        }
        response = await mutationName(values.document, ClientType, ClientId);
      }

      if (response && (response.status === 200 || response.status === 201)) {
        props.onClose();
        if (props.onAction && typeof props.onAction === "function") {
          props.onAction();
        }
        Swal.fire({
          icon: 'success',
          title: 'Success!',
          text: 'Document has been uploaded successfully.',
        });
        setUploadedDocuments([...uploadedDocuments, values.document]);
      } else {
        throw new Error('Upload failed');
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error!',
        text: 'An error occurred while processing your request. Please try again later.',
      });
    }
    setSubmitting(false);
    props.onClose();
  };
  const handleDownload = async () => {
   switch (uploadType) {
     case "case":
       await downloadCaseFile();
       break;
     case "individualClient":
       await downloadIndividualClientFile();
       break;
     case "corporateClients":
       await downloadCorporateClientFile();
       break;
     case "individual":
     case "corporate":
       await downloadCaseForClientFile();
       break;
    
   }
  //  await downloadCorporateClientFile();
 };
  return (
    <React.Fragment>
      <Dialog open={open} onClose={onClose}>
        <DialogTitle sx={{ color: colors.grey[100] }}>
          Upload Document
        </DialogTitle>
        <Formik
          initialValues={{
            document: null,
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
            setFieldValue,
            isSubmitting,
          }) => (
            <form onSubmit={handleSubmit}>
              <DialogContent>
                <DialogContentText sx={{ color: colors.greenAccent[400] }}>
                  Please upload your document.
                </DialogContentText>
                <DialogContentText sx={{ color: colors.blueAccent[400] }}>
                  Do not have a template?{" "}
                  <Button
                    onClick={handleDownload}
                    variant="outlined"
                    color="secondary"
                    textDecoration="underline"
                  >
                    Download
                  </Button>
                </DialogContentText>
                <TextField
                  fullWidth
                  type="file"
                  label="Document"
                  name="document"
                  onChange={(event) =>
                    setFieldValue("document", event.currentTarget.files[0])
                  }
                  onBlur={handleBlur}
                  error={touched.document && !!errors.document}
                  helperText={touched.document && errors.document}
                  margin="normal"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                <List>
                  {uploadedDocuments.map((doc, index) => (
                    <ListItem key={index}>
                      <ListItemText primary={doc.name} />
                    </ListItem>
                  ))}
                </List>
              </DialogContent>
              <DialogActions>
                <Button
                  color="error"
                  variant="outlined"
                  onClick={props.onClose}
                >
                  Cancel
                </Button>
                <Button
                  variant="outlined"
                  type="submit"
                  disabled={isSubmitting}
                  color="success"
                >
                  {isSubmitting ? "Uploading..." : "Upload"}
                </Button>
              </DialogActions>
            </form>
          )}
        </Formik>
      </Dialog>
    </React.Fragment>
  );
}